import { PDFDocument } from "pdf-lib";
import { Store } from "../states/store";

export const getJSONheader = () => {
  // const token = localStorage.getItem('token');
  const token = Store.getState().auths.token;
  return {
    headers: {
      // 'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  };
};

export const getFormDataHeader = () => {
  const token = Store.getState().auths.token;
  return {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
};

interface currencyTypes {
  iso: string;
  slug: "NGN" | "USD";
}

export const formatCurrency = (currencyType: currencyTypes) => {
  return new Intl.NumberFormat(currencyType.iso, {
    style: "currency",
    currency: currencyType.slug,
  });
};

export function sumPrices(data: any) {
  let totalPrice = 0;

  for (const item of data) {
    totalPrice += item.price;
  }

  return totalPrice;
}

export const fetchPageOptions = async (pdfUrl: string) => {
  try {
    const existingPdfBytes = await fetch(pdfUrl).then((res) =>
      res.arrayBuffer()
    );
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const pages = pdfDoc.getPages();
    const pageCount = pages.length;

    // Generate an array of page indices
    return Array.from({ length: pageCount }, (_, index) => index);
  } catch (error) {
    console.error("Error fetching page options:", error);
    return [];
  }
};

export const getFlagStyle = (role: string) => {
  switch (role) {
    case "DEFENDANT":
      return "bg-[#FFECEB] text-[#C62828]";
    case "PLAINTIFF":
      return "bg-[#E3F2FD] text-[#1565C0]";
    default:
      return "bg-gray-100 text-gray-700";
  }
};

export const filterOptions = [
  "ALL",
  "PENDING",
  "ACCEPTED",
  "REJECTED",
  "ON GOING",
  "IN COURT",
  "CONCLUDED",
  "DONE",
  "ASSIGN",
  "REASSIGN",
  "RECALLED",
  "READY FOR HANDLING",
  "FRESH CASE",
  "MENTION",
  "MOTION",
  "PART HEARD",
  "REASSIGNED",
  "SERVED",
  "NOT SERVED",
  "JOIN REQUEST",
  "APPROVED JOIN REQUEST",
];
